import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { APIDealerBlockedServices } from 'src/services/api-services/api-dealer-blocked-services';
import { WorkshopsComponent } from '../../../../workshops/workshops.component';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'src/services/helperService';

@Component({
    selector: 'app-delete-lock-settings',
    templateUrl: './delete-lock-settings.dialog.html',
    styleUrls: ['./delete-lock-settings.dialog.sass'],
    standalone: false
})
export class deleteLockSettingsDialog {
  constructor(
    public dialogRef: MatDialogRef<WorkshopsComponent>,
    @Inject(MAT_DIALOG_DATA) public lockSetting: any,
    public dealerBlockedService: APIDealerBlockedServices,
    public helperService: HelperService,
    private translate: TranslateService
  ) {}
  LoadingSavingLocks:boolean = false;
  ngOnInit(): void {}
  // Funtion delete or cancel dialog
  onCancel(): void {
    this.dialogRef.close();
  }
  onSave(): void {
    this.LoadingSavingLocks = true
    this.dealerBlockedService
      .deletClusterlocksettings(
        this.lockSetting.workshopId,
        this.lockSetting.initialDate,
        this.lockSetting.finalDate,
        this.lockSetting.hourInitial,
        this.lockSetting.hourFinal
      )
      .pipe(finalize(() => null))
      .subscribe({
        next: (response) => {
          if (response.message === 'Data Deleted Successfully') {
            const translateText = this.translate.instant(
              'ToastDeleteBlockHistoryWorkshop'
            );
            this.helperService.showAlert =true
            this.helperService.typeAlert ="success"
            this.helperService.messageAlert =translateText

            setTimeout(() => {
              this.helperService.showAlert =false

              }, 7000)

            this.LoadingSavingLocks = false
            this.dialogRef.close();
          }
        },
        error: (failed) => {
          // Validation 401 error
          if(failed.status === 401){
            this.helperService.logoutToken()
          }

          this.LoadingSavingLocks = false

          let mensageError = failed.error.text;
          if (
            mensageError ===
            "{ 'code': '400', 'message': 'Exception: An error occurred while saving the entity changes. See the inner exception for details.' }"
          ) {
          }
        },
      });
  }
}
